/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DigitizingMelcoDigitizingModelsDigitizingGarmentTypeListItem,
    DigitizingMelcoDigitizingModelsDigitizingGarmentTypeListItemFromJSON,
    DigitizingMelcoDigitizingModelsDigitizingGarmentTypeListItemFromJSONTyped,
    DigitizingMelcoDigitizingModelsDigitizingGarmentTypeListItemToJSON,
    DigitizingMelcoModelsCustomWarning,
    DigitizingMelcoModelsCustomWarningFromJSON,
    DigitizingMelcoModelsCustomWarningFromJSONTyped,
    DigitizingMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingGarmentTypeListItem
 */
export interface DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingGarmentTypeListItem {
    /**
     * 
     * @type {Array<DigitizingMelcoDigitizingModelsDigitizingGarmentTypeListItem>}
     * @memberof DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingGarmentTypeListItem
     */
    list: Array<DigitizingMelcoDigitizingModelsDigitizingGarmentTypeListItem>;
    /**
     * 
     * @type {Array<DigitizingMelcoModelsCustomWarning>}
     * @memberof DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingGarmentTypeListItem
     */
    warning_list?: Array<DigitizingMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingGarmentTypeListItem
     */
    total: number;
}

export function DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingGarmentTypeListItemFromJSON(json: any): DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingGarmentTypeListItem {
    return DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingGarmentTypeListItemFromJSONTyped(json, false);
}

export function DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingGarmentTypeListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingGarmentTypeListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(DigitizingMelcoDigitizingModelsDigitizingGarmentTypeListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(DigitizingMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingGarmentTypeListItemToJSON(value?: DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingGarmentTypeListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(DigitizingMelcoDigitizingModelsDigitizingGarmentTypeListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(DigitizingMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


